import { ReactNode } from "react";
import { Stack, Typography } from "@mui/material";

// Built from the DS-Mockups "TOP BANNER CTA" frame (node 1518:2031). That
// mockup sits on an app screenshot shrunk to 0.75×, so every Figma value is
// scaled back up by 4/3 here to keep its proportions against the real app.
const ICONS = "/icons/sketchup-promo";
export const px = (figma: number) => `${(figma * 4) / 3}px`;

/** An exported SVG at the banner's scale, aspect ratio kept. */
export const Icon = ({
  name,
  w,
  h,
}: {
  name: string;
  w: number;
  h: number;
}) => (
  <img
    src={`${ICONS}/${name}.svg`}
    alt=""
    style={{ display: "block", width: px(w), height: px(h) }}
  />
);

const LogoTile = ({ children }: { children: ReactNode }) => (
  <Stack
    alignItems="center"
    justifyContent="center"
    sx={{
      width: px(33.75),
      height: px(33.75),
      flexShrink: 0,
      backgroundColor: "#fff",
      border: `${px(0.5)} solid #DADADA`,
      borderRadius: px(7.5),
    }}
  >
    {children}
  </Stack>
);

/** The "MattoBoard × SketchUp" logo cluster. */
export const SketchupLogoPair = () => (
  <Stack
    direction="row"
    alignItems="center"
    spacing={px(6)}
    sx={{ flexShrink: 0 }}
  >
    <LogoTile>
      <Icon name="mattoboard-logo" w={22.3833} h={12.75} />
    </LogoTile>
    <Typography
      aria-hidden
      sx={{
        fontSize: px(13.5),
        color: "#A1A1AA",
        lineHeight: "normal",
      }}
    >
      ×
    </Typography>
    <LogoTile>
      <Icon name="sketchup-logo" w={16.6154} h={18} />
    </LogoTile>
  </Stack>
);
